<template>
  <div id="PerformanceIndividualExpertisePage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="نمودار عملکرد متناسب با تخصص فردی"></ActionBar>
    <div class="row">
      <div class="col-12 col-sm-6 col-md-4">
        <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">انتخاب سال:</span></div>
        <v-select
            v-model.number="selectedYear"
            :items="years"
            class="input-border"
            dense
            hide-details
            placeholder="انتخاب سال"
            solo
            @change="setYear">
        </v-select>
      </div>
      <div class="col-12 col-sm-6 col-md-4">
        <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">انتخاب ماه:</span></div>
        <v-select
            ref='monthPicker'
            v-model.number="selectedMonth"
            :disabled="!showMonthPicker"
            :items="months"
            :menu-props="{value:openMonthPicker}"
            class="input-border"
            dense
            hide-details
            item-text="text"
            item-value="id"
            placeholder="انتخاب ماه"
            solo
            @change="setDate"
            @click="openMonthPicker  = true">
        </v-select>
      </div>
      <div class="col-6 col-sm-4 col-md-2 text-left align-self-end">
        <v-btn :disabled="selectedYear === null || selectedMonth===null" block class="px-8" color="primary" rounded
               @click="search">
          جستجو
        </v-btn>
      </div>
    </div>
    <div class="row container mx-auto no-gutters p-0 mt-10">
      <div v-if="dataLoading" class="col-12 mt-10 col-md-6 col-lg-3 mx-auto text-center">
        در حال جستجو
        <v-progress-linear
            color="deep-purple accent-4"
            height="6"
            indeterminate
            rounded
        ></v-progress-linear>
      </div>
      <div v-else-if="isLoaded" class="col-12 col-sm-10  mx-auto ">
        <div v-if="!hasReport" class="mx-2 mt-5">
          <div class="col-12">
            <v-alert
                border="bottom"
                class="text-center"
                color="forth"
                dark>
              گزارشی برای تاریخ انتخاب شده وجود ندارد.
            </v-alert>
          </div>
        </div>
        <div v-else>
          <MultipleBarChart v-if="isChartLoaded"
                            :chart-label="loadChartLabel()"
                            :chart-standard-data="loadChartStandardData()"
                            :chart-user-data="loadChartUSerData()"
                            :standard-label="'زمان استاندارد'"
                            :user-label="'زمان شما'"/>
        </div>
      </div>
    </div>
    <FooterMenu/>
  </div>
</template>

<script>
import ActionBar from "../../components/ActionBar";
import FooterMenu from "../../components/FooterMenu";
import MultipleBarChart from "../../components/MultipleBarChart";

export default {
  name: "PerformanceIndividualExpertise",
  metaInfo: {
    title: 'مسیربرتر-نمودار عملکرد متناسب با تخصص فردی'
  },
  components: {MultipleBarChart, FooterMenu, ActionBar},
  data: function () {
    return {
      openMonthPicker: false,
      showMonthPicker: false,
      years: [],
      selectedYear: null,
      dataLoading: false,
      isChartLoaded: false,
      isLoaded: false,
      hasReport: false,
      selectedMonth: null,
      months: [
        {id: 1, text: 'فروردین'},
        {id: 2, text: 'اردیبهشت'},
        {id: 3, text: 'خرداد'},
        {id: 4, text: 'تیر'},
        {id: 5, text: 'مرداد'},
        {id: 6, text: 'شهریور'},
        {id: 7, text: 'مهر '},
        {id: 8, text: 'آبان '},
        {id: 9, text: 'آذر '},
        {id: 10, text: 'دی'},
        {id: 11, text: 'بهمن'},
        {id: 12, text: 'اسفند '},
      ],
      startDate: null,
      endDate: null,
      chartUserData: [],
      chartLabel: [],
      chartStandardData: []
    }
  },
  mounted() {
    let year = this.$convertDate((new Date()).toISOString()).slice(0, 4)
    this.years.push(year - 1, parseInt(year))

  },
  methods: {
    setYear() {
      this.showMonthPicker = true
      // this.openMonthPicker = true
    },
    setDate() {
      this.openMonthPicker = null

      this.startDate = this.$chooseMonth(this.selectedMonth, this.selectedYear).startDate
      this.endDate = this.$chooseMonth(this.selectedMonth, this.selectedYear).endDate

    },
    search() {
      this.dataLoading = true;
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("StartDate", this.startDate);
      urlencoded.append("EndDate", this.endDate);
      urlencoded.append("StudentProfileID", this.$getUserData().studentID);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ReportManagement/_PerformanceIndividualExpertise", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.isLoaded = true
            if (json.length > 0) {
              this.hasReport = true
              this.isChartLoaded = true
              let items = json
              let labels = []
              let standardData = []
              let userData = []
              for (let i = 0; i < items.length; i++) {
                labels.push(items[i].EvaluationCategoryName)
                standardData.push(items[i].StandardMinutes)
                userData.push(items[i].Minutes)
              }
              this.chartUserData = userData
              this.chartLabel = labels
              this.chartStandardData = standardData

            } else {
              this.hasReport = false
            }

            this.dataLoading = false
          })
          .catch(error => console.log('error', error));
    },
    loadChartStandardData() {
      let arr = this.chartStandardData;
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      return res;

    },
    loadChartUSerData() {
      let arr = this.chartUserData;
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      return res;

    },
    loadChartLabel() {
      let arr = this.chartLabel;
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      return res;

    },
  }
}
</script>

<style scoped>

</style>
